// extracted by mini-css-extract-plugin
export default {"summarySection":"StudentNotesSummaryPanel_summarySection__4vL6u"};